module.exports = __webpack_public_path__ + "img/rating-page-slider-desktop-5.3ea1d68f.png";